module.exports = __webpack_public_path__ + "static/media/33.60589946.jpg";